import { render } from "./ImprimirEtiqueta.vue?vue&type=template&id=f351efec&scoped=true"
import script from "./ImprimirEtiqueta.vue?vue&type=script&lang=js"
export * from "./ImprimirEtiqueta.vue?vue&type=script&lang=js"

import "./ImprimirEtiqueta.vue?vue&type=style&index=0&id=f351efec&scoped=true&lang=css"

import exportComponent from "/woodpecker/src/github.com/Multpex/multpex.front.gestao/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f351efec"]])

export default __exports__
import QPage from 'quasar/src/components/page/QPage.js';
import qInstall from "../../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QPage});
